import React from 'react';
import styled from 'styled-components';
import TunnelStatus from 'features/POSRegisters/interfaces/TunnelStatus';

const StyledTunnelStatusIndicator = styled.div`
  background-color: transparent;
  border-radius: 50%;
  height: 12px;
  width: 12px;
  margin-right: 12px;

  &.stable {
    background-color: ${props => props.theme.green};
  }
  &.standby {
    background-color: ${props => props.theme.grey};
  }
  &.disconnected {
    background-color: ${props => props.theme.red};
  }
`;

const statusClass: Record<string, string> = {
  [TunnelStatus.STABLE]: 'stable',
  [TunnelStatus.STANDBY]: 'standby',
  [TunnelStatus.DISCONNECTED]: 'disconnected',
  [TunnelStatus.UNKNOWN]: '',
};

function TunnelStatusIndicator({status}: {status: string}) {
  const indicatorClass: string | undefined = statusClass[status];

  return <StyledTunnelStatusIndicator className={indicatorClass ? indicatorClass : ''} />;
}

export default TunnelStatusIndicator;
